export default __webpack_public_path__ + "static/media/fieldofwar.5643c733.png";